import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { ABTest } from '@freelancer/abtest';
import { Datastore } from '@freelancer/datastore';
import { IconSize } from '@freelancer/ui/icon';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { UiConfig } from '@freelancer/ui/ui.interface';
import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  template: `
    <app-award-modal-body
      *ngIf="(cartVariant$ | async) === false"
      class="AwardModalBody"
      [bidId]="bidId"
    ></app-award-modal-body>
    <app-award-modal-body-cart
      *ngIf="(cartVariant$ | async) === true"
      class="AwardModalBody"
      [bidId]="bidId"
    ></app-award-modal-body-cart>
    <app-award-modal-sidebar class="AwardModalSidebar">
    </app-award-modal-sidebar>
  `,
  styleUrls: ['./award-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwardModalComponent implements OnInit {
  IconSize = IconSize;

  @Input() bidId: number;
  @Input() projectId: number;

  cartVariant$: Rx.Observable<boolean>;

  constructor(
    private abtest: ABTest,
    private datastore: Datastore,
    @Inject(UI_CONFIG) private uiConfig: UiConfig,
  ) {}

  ngOnInit() {
    if (this.abtest.isWhitelistUser()) {
      this.cartVariant$ = Rx.of(true);
    } else if (this.uiConfig.theme === 'arrow') {
      this.cartVariant$ = Rx.of(false);
    } else {
      this.cartVariant$ = this.datastore
        .collection('projectViewProjects', query =>
          query.where('id', '==', this.projectId),
        )
        .valueChanges()
        .pipe(
          switchMap(projects => {
            if (
              projects[0].ownerId > 33337777 &&
              projects[0].language.includes('en') &&
              !projects[0].local
            ) {
              return this.abtest
                .getUserExperimentVariation('T65827-employer-pvp-webapp-v2') // TODO replace with new test
                .pipe(map(variant => variant === 'test'));
            }
            return Rx.of(false);
          }),
        );
    }
  }
}
